export const FII_DII = "FII_DII";
export const FII_MSG = "FII_MSG";
export const FII_CLEAR_MSG = "FII_CLEAR_MSG";
export const FII_DII_ERROR = "FII_DII_ERROR";
export const FII_DII_HIDE_ERROR = "FII_DII_HIDE_ERROR";
export const FII_DII_START_LOADER = "FII_DII_START_LOADER";
export const FII_DII_STOP_LOADER = "FII_DII_STOP_LOADER";
